/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GespeicherteAuswertungWert } from './GespeicherteAuswertungWert';
import {
    GespeicherteAuswertungWertFromJSON,
    GespeicherteAuswertungWertFromJSONTyped,
    GespeicherteAuswertungWertToJSON,
} from './GespeicherteAuswertungWert';

/**
 * Ein Lesezeichen der Kreuztabelle: dieselben Angaben, die der Dialog „Auswertung" entgegennimmt, unter einem Namen abgelegt.
 * @export
 * @interface GespeicherteAuswertung
 */
export interface GespeicherteAuswertung {
    /**
     * Kennung des Lesezeichens. NICHT der Name: Wer ein Lesezeichen umbenennt, soll nicht ein zweites bekommen.
     * @type {string}
     * @memberof GespeicherteAuswertung
     */
    id?: string;
    /**
     * Der angezeigte Name, etwa „v:Anbieter/Bezeichnung / h:Person / 14.10.2026". Er wird beim Speichern vorgeschlagen und ist aenderbar.
     * @type {string}
     * @memberof GespeicherteAuswertung
     */
    name?: string;
    /**
     * Zeitpunkt des Speicherns, als Text (ISO-8601).
     * @type {string}
     * @memberof GespeicherteAuswertung
     */
    erstellt?: string;
    /**
     * Feld-Kennungen der senkrechten Gliederung, in ihrer Reihenfolge.
     * @type {Array<string>}
     * @memberof GespeicherteAuswertung
     */
    vertikal?: Array<string>;
    /**
     * Feld-Kennungen der waagerechten Gliederung, in ihrer Reihenfolge.
     * @type {Array<string>}
     * @memberof GespeicherteAuswertung
     */
    horizontal?: Array<string>;
    /**
     * 
     * @type {Array<GespeicherteAuswertungWert>}
     * @memberof GespeicherteAuswertung
     */
    werte?: Array<GespeicherteAuswertungWert>;
    /**
     * Summenzeilen anzeigen?
     * @type {boolean}
     * @memberof GespeicherteAuswertung
     */
    summen?: boolean;
    /**
     * Zellen mit 0 leer lassen — und die dadurch leeren Zeilen weglassen. Die Rechnung bleibt davon unberuehrt.
     * @type {boolean}
     * @memberof GespeicherteAuswertung
     */
    nullenAusblenden?: boolean;
}

/**
 * Check if a given object implements the GespeicherteAuswertung interface.
 */
export function instanceOfGespeicherteAuswertung(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GespeicherteAuswertungFromJSON(json: any): GespeicherteAuswertung {
    return GespeicherteAuswertungFromJSONTyped(json, false);
}

export function GespeicherteAuswertungFromJSONTyped(json: any, ignoreDiscriminator: boolean): GespeicherteAuswertung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'erstellt': !exists(json, 'erstellt') ? undefined : json['erstellt'],
        'vertikal': !exists(json, 'vertikal') ? undefined : json['vertikal'],
        'horizontal': !exists(json, 'horizontal') ? undefined : json['horizontal'],
        'werte': !exists(json, 'werte') ? undefined : ((json['werte'] as Array<any>).map(GespeicherteAuswertungWertFromJSON)),
        'summen': !exists(json, 'summen') ? undefined : json['summen'],
        'nullenAusblenden': !exists(json, 'nullenAusblenden') ? undefined : json['nullenAusblenden'],
    };
}

export function GespeicherteAuswertungToJSON(value?: GespeicherteAuswertung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'erstellt': value.erstellt,
        'vertikal': value.vertikal,
        'horizontal': value.horizontal,
        'werte': value.werte === undefined ? undefined : ((value.werte as Array<any>).map(GespeicherteAuswertungWertToJSON)),
        'summen': value.summen,
        'nullenAusblenden': value.nullenAusblenden,
    };
}

